<script>
    import { onDestroy, onMount } from 'svelte';
    import {
        store,
        store_offer,
        isStep5Or6,
        shouldVerifyPromotions,
        isVerifyingPromotions,
    } from '../../Store.svelte';
    import { getExtras, getPromos } from '../../Util.svelte';
    import MobileCart from './MobileCart.svelte';
    import CartInformation from './CartInformation.svelte';
    import Preloader from '../Preloader.svelte';

    let step;
    let isMobile = false;
    let isFiveOrSix;
    let isModalVisible = false;

    let total = 0;

    const handleVerifyPromotions = async () => {
        isVerifyingPromotions.set(true);

        getPromos(getExtras($store, $store_offer), (response) => {
            $store.requestedServices.promotions = response;
            isVerifyingPromotions.set(false);
            shouldVerifyPromotions.set(false);
        });
    };

    onDestroy(() => {
        $store.purchaseStatus.total = total;
    });

    onMount(() => {
        checkScreenSize();

        const mediaQuery = window.matchMedia('(max-width: 767px)');
        const handler = (event) => {
            isMobile = event.matches;
        };

        mediaQuery.addEventListener('change', handler);

        return () => {
            mediaQuery.removeEventListener('change', handler);
        };
    });

    if (window.location.href.includes('compra/configura')) {
        handleVerifyPromotions();
    }

    $: {
        step = $store.settings.location.step;
        isFiveOrSix = step == 0 || step == 5 || step == 6 || step == 7;

        isStep5Or6.set(isFiveOrSix);
    }

    function checkScreenSize() {
        isMobile = window.matchMedia('(max-width: 767px)').matches;
    }
</script>

<section class={isFiveOrSix ? 'show-summary' : 'summary-modal'}>
    <div class="sidebar__wrapper m-t-60">
        <div class={isMobile ? 'show-summary' : 'sidebar'}>
            <CartInformation />
        </div>
        {#if isMobile}
            <MobileCart
                {isModalVisible}
                {isMobile}
                on:verifyPromotions={handleVerifyPromotions}
            />
        {/if}
    </div>
</section>

{#if $isVerifyingPromotions}
    <div class="loader-overlay">
        <Preloader
            status="Estamos buscando las mejores promociones y canales para ti. Un momento, por favor."
        />
    </div>
{/if}
